// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/ui-core/app-state.ts
// Parameters       : none — this file is byte-identical across the fleet
// Destination      : packages/fleet/ui/src/app-state.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo listto-app
//     node fleet/fleet.ts check --repo listto-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { createSignal } from "solid-js";

/**
 * Shared state to coordinate between the InitialSyncOverlay and the AppLayout.
 * This allows the app to signal when it is fully mounted and ready to be displayed.
 */
const [isAppReady, setAppReady] = createSignal(false);
const [isBootComplete, setBootComplete] = createSignal(false);

export const appState = {
  isReady: isAppReady,
  markAsReady: () => setAppReady(true),
  isBootComplete,
  markBootComplete: () => setBootComplete(true),
};
